import { CreateMunicipalPropertyInput } from "@/graphql/generated/graphql";
import { extractGraphQLErrorCode } from "@/lib/extract-graphql-error-code";

export type PropertyCsvImportStatus = "success" | "failed" | "unknown" | "skipped";
interface ImportPropertyCsvInput {
  inputList: CreateMunicipalPropertyInput[];
  createProperty: (input: CreateMunicipalPropertyInput) => Promise<unknown>;
  onProgress: (completed: number) => void;
}

export async function importPropertyCsv({
  inputList,
  createProperty,
  onProgress,
}: ImportPropertyCsvInput): Promise<PropertyCsvImportStatus[]> {
  const statusList: PropertyCsvImportStatus[] = [];
  for (const input of inputList) {
    try {
      await createProperty(input);
      statusList.push("success");
    } catch (error) {
      const code = extractGraphQLErrorCode(error);
      if (code === "BAD_USER_INPUT" || code === "BAD_REQUEST" || code === "CONFLICT") statusList.push("failed");
      else {
        statusList.push("unknown");
        break;
      }
    }
    onProgress(statusList.length);
  }
  return [...statusList, ...inputList.slice(statusList.length).map((): PropertyCsvImportStatus => "skipped")];
}
